// Lado del navegador: si hay una pasarela activa (Mercado Pago o Stripe), manda al cliente a pagar allá; si no, la pantalla sigue con su camino de práctica.
const RUTA = { mercadopago: "/api/pagos/mercadopago/preferencia", stripe: "/api/pagos/stripe/sesion" } as const;

/** Devuelve true cuando ya redirigió al cliente (la pantalla no debe seguir). Lanza un error con mensaje legible si la pasarela no pudo abrirse. */
export async function irAPagarEnLinea(folio: string): Promise<boolean> {
  const { proveedor } = await fetch("/api/pagos/proveedor", { cache: "no-store" }).then((r) => r.json()).catch(() => ({ proveedor: null })) as { proveedor: keyof typeof RUTA | null };
  if (!proveedor || !RUTA[proveedor]) return false;
  const r = await fetch(RUTA[proveedor], { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ folio }) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok || typeof d.url !== "string") throw new Error(d.mensaje ?? "No pudimos abrir el pago en línea.");
  window.location.assign(d.url);
  return true;
}
